<template>
  <el-dialog
    class="theme-dialog dialog-center dialog-body-0"
    :title="dialogTitle"
    width="770px"
    top="0"
    :center="true"
    :close-on-click-modal="false"
    :visible.sync="visibility"
  >
    <div class="p-6 box-border flex flex-col border-b border-solid border-border-gray" style="height: 570px">
      <div class="mb-4 flex items-center text-medium" v-if="modeType === 'adviceResult'">
        <p class="text-theme-black-850">维度名称：</p>
        <p class="text-theme-black-650">{{source.title || '—'}}</p>
      </div>
      <div class="mb-4 flex items-center">
        <p class="text-medium text-theme-black-850">分值范围：</p>
        <el-input-number
          size="small"
          controls-position="right"
          style="width: 88px"
          :min="0"
          :max="999999999"
          :precision="0"
          v-model="minScore"
        />
        <p class="mx-2 text-medium text-theme-black-850">≤ 得分 ≤</p>
        <el-input-number
          size="small"
          controls-position="right"
          style="width: 88px"
          :min="0"
          :max="999999999"
          :precision="0"
          v-model="maxScore"
        />
      </div>
      <div class="mb-4 flex items-center text-medium" v-if="modeType === 'adviceResult'">
        <p class="text-theme-black-850">当前总分：</p>
        <p class="text-theme-black-650">
          共&nbsp;<span class="text-theme">{{source.score || 0}}</span>&nbsp;分
        </p>
      </div>
      <div class="mb-2 text-medium text-theme-black-850">结果建议：</div>
      <div class="flex-1">
        <senior-editor v-model="adviceValue" image style="height: 100%"/>
      </div>
    </div>
    <template #footer>
      <footer class="text-right">
        <el-button class="normal-button" size="small" @click="cancelHandle">取消</el-button>
        <el-button
          class="normal-button"
          size="small"
          type="primary"
          :loading="confirmLoading"
          @click="confirmHandle"
        >确定</el-button>
      </footer>
    </template>
  </el-dialog>
</template>

<script>
import SeniorEditor from '@/components/base/SeniorEditor'
import dialogMixins from '@/mixins/dialog'
import { addResultAdvice } from '@/api/wenjuan/dimensionScore'

export default {
  name: 'AddAdviceResultDialog',
  mixins: [dialogMixins],
  components: {
    SeniorEditor
  },
  props: {
    onConfirm: {
      type: [Function, null],
      default: null
    },
    dialogTitle: {
      type: String,
      default: ''
    },
    source: {
      type: Object,
      default: () => ({})
    },
    // 弹窗类型 测评建议:testResult 维度建议:adviceResult
    modeType: {
      type: String,
      default: ''
    },
    // 操作类型 新增:add 编辑:edit
    handlerType: {
      type: String,
      default: ''
    },
    // 结果集所有分值范围(用于校验是否有重复值)
    scoreRanges: {
      type: Array,
      default: () => []
    },
  },
  data() {
    return {
      adviceValue: '',
      minScore: null,
      maxScore: null,
      confirmLoading: false,
    }
  },
  watch: {
    visibility(bool) {
      if (bool) {
        this.setValue();
      }
    }
  },
  mounted() {
    this.setValue();
  },
  methods: {
    setValue() {
      const { scoreLowerBound, scoreUpperBound, suggestion } = this.source;
      this.adviceValue = suggestion ?? '';
      this.minScore = scoreLowerBound ?? null;
      this.maxScore = scoreUpperBound ?? null;
    },
    cancelHandle() {
      this.visibility = false;
      this.adviceValue = '';
      this.minScore = null;
      this.maxScore = null;
    },
    successHandler() {
      if (typeof this.onConfirm === 'function') {
        this.onConfirm();
      } else {
        this.$emit('confirm');
      }
    },
    checkValue() {
      const nilsEnum = ['', null, undefined, NaN];
      if (nilsEnum.includes(this.minScore)) {
        this.$message.warning('请输入分值下限');
        return false;
      }
      if (nilsEnum.includes(this.maxScore)) {
        this.$message.warning('请输入分值上限');
        return false;
      }
      // 校验值大小
      if (this.minScore > this.maxScore) {
        this.$message.warning('左边分值须小于等于右边分值');
        return false;
      }
      // 校验范围是否重复
      const rsList = [];
      for (const sr of this.scoreRanges) {
        rsList.push(sr.minScore);
        rsList.push(sr.maxScore);
      }
      if (rsList.length === 0) return true;
      rsList.sort((a, b) => a - b);
      const max = Math.max(...rsList);
      const min = Math.min(...rsList);
      const isInnerRange = !((this.minScore < min && this.maxScore < min)
        || (this.minScore > max && this.maxScore > max));
      if (isInnerRange) {
        const rangeList = [];
        for (let i = 0; i < rsList.length; i++) {
          if (rsList.length - 1 === i) break;
          rangeList.push(`${rsList[i]}-${rsList[i + 1]}`);
        }
        const passRangeList = rangeList.filter(f => this.scoreRanges.every(e => `${e.minScore}-${e.maxScore}` !== f));
        for (const pr of passRangeList) {
          const [min, max] = pr.split('-');
          const isMin = min < this.minScore && this.minScore < max;
          const isMax = min < this.maxScore && this.maxScore < max;
          if (isMin && isMax) return true;
        }
        this.$message.warning('分值范围重复，请重新输入');
        return false;
      }
      return true;
    },
    getParams() {
      const dimensionOrSuggestion = ({ testResult: 0, adviceResult: 1 })[this.modeType] ?? '';
      if (this.handlerType === 'add') {
        const params = {
          dimensionOrSuggestion,
          type: 0, // 新增
        };
        const req = {
          scoreLowerBound: this.minScore,
          scoreUpperBound: this.maxScore,
          suggestion: this.adviceValue,
        }
        Object.assign(params, this.modeType === 'adviceResult' ? { title: this.source.title ?? '' } : {});
        return { req, params };
      } else if (this.handlerType === 'edit') {
        const { scoreLowerBound, scoreUpperBound, suggestion, title, key } = this.source;
        const params = {
          dimensionOrSuggestion,
          type: 1, // 编辑
          key,
        }
        const req = {};
        if (this.minScore !== scoreLowerBound) {
          Object.assign(req, { scoreLowerBound: this.minScore });
        }
        if (this.maxScore !== scoreUpperBound) {
          Object.assign(req, { scoreUpperBound: this.maxScore });
        }
        if (this.adviceValue !== suggestion) {
          Object.assign(req, { suggestion: this.adviceValue });
        }
        Object.assign(params, this.modeType === 'adviceResult' ? { title: title ?? '' } : {});
        return { req, params };
      }
      return { req: {}, params: {} }
    },
    confirmHandle() {
      if (!this.modeType || !this.handlerType) {
        this.$message.warning('未知操作类型');
        return;
      }
      const isPass = this.checkValue();
      if (isPass) {
        const { req, params } = this.getParams();
        this.confirmLoading = true;
        addResultAdvice(req, params).then((res) => {
          const { code, msg } = res.data || {};
          if (code === 0) {
            this.$message.success(`${this.dialogTitle}成功`);
            this.cancelHandle();
            this.successHandler();
          } else {
            this.$message.error(msg ?? `${this.dialogTitle}失败`);
          }
        }).catch(() => {
          this.$message.error(`${this.dialogTitle}失败`);
        }).finally(() => {
          this.confirmLoading = false;
        });
      }
    }
  }
}
</script>